import React, { useState } from "react";
import MetaTags from "react-meta-tags";
import PropTypes from "prop-types";
import {
  Alert,
  Col,
  Container,
  Form,
  Label,
  Row,
} from "reactstrap";
import styles from "./UserAddPublic.module.css"

import SweetAlert from "react-bootstrap-sweetalert";

// Redux
import { connect, useDispatch } from "react-redux";
import { withRouter, useHistory } from "react-router-dom";
import { contactsCreateLogin } from "../../../store/contacts/actions";




const UserAddPublic = (props) => {
    const history = useHistory();
    const dispatch = useDispatch();



  const [formData, setFormData] = useState({
    username: "",
    password: "",
    confirm_password: "",
    first_name: "",
    last_name: "",
    contactType: 'PERSONA NATURAL',
    documentType: "",
    documentNumber: "",
    

  });

  const { username, password, confirm_password, first_name, last_name,documentNumber } =
    formData;

  const onChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };


  const onSubmit = (e) => {
    e.preventDefault();
    dispatch (contactsCreateLogin(formData));
  };

  const redirect = () => {
    history.push("/login");
  };


  const [showPassword, setShowPassword] = useState(false);

const togglePasswordVisibility = () => {
  setShowPassword(!showPassword);
};
  const [showConfirm, setShowConfirm] = useState(false);

const toggleConfirmVisibility = () => {
  setShowConfirm(!showConfirm);
};
  
  return (
  <React.Fragment>
        <MetaTags>
          <title>tccontrol| Usuarios </title>
        </MetaTags>

      <Container fluid>
        <Row className="col-lg-12 justify-content-center mx-5 mt-5">
          <Col lg={6}>
                {props.contactsCreated.id ? (
                  <SweetAlert
                    title="Hecho!"
                    success
                    timeout={1000}
                    showConfirm={false}
                    onConfirm={() => {                    
                      redirect();
                    }}
                  >
                    Se ha creado el usuario, accede con tu usuario y contraseña.
                  </SweetAlert> 
          
          ) : null}
           <Row className="col-lg-12 justify-content-center  mt-5">

           
          <h4 className={styles["tittle"]}>Crear Usuario</h4>
            <Form className={styles["form"]} 
            onSubmit={onSubmit}
            >

                <Row>
                <Col  sm='12' md='6'>
                    <Label
                      for="username"
                      className={styles["label"]}
                    >
                      Correo electrónico
                    </Label>
                    <input
                      className= {styles["input"]}
                      id="username"
                      name="username"
                      type="email"
                      onChange={onChange}
                      value= {username}
                      autoFocus
                      required
      
                    />
                    {props.error && props.error.username ? (
                      <Alert color = 'danger' className="mt-2">{props.error.username}</Alert>
                    ):null}
                  </Col>
                  <Col  sm='12' md='6'>
                    <Label
                      for="first_name"
                      className={styles["label"]}
                    >
                      Nombre
                    </Label>
                    <input
                      className= {styles["input"]}
                      id="first_name"
                      name="first_name"
                      type="text"
                      onChange={onChange}
                      value= {first_name}                    
                      required
      
                    />
                    {props.error && props.error.first_name ? (
                      <Alert color = 'danger' className="mt-2">{props.error.first_name}</Alert>
                    ):null}
                  </Col>
                </Row>
                <Row>
                <Col  sm='12' md='6'>
                    <Label
                      for="last_name"
                      className={styles["label"]}
                    >
                      Apellido
                    </Label>
                    <input
                      className= {styles["input"]}
                      id="last_name"
                      name="last_name"
                      type="text"
                      onChange={onChange}
                      value={last_name}
                      required 
                    />
                    {props.error && props.error.last_name ? (
                    <Alert color = 'danger' className="mt-2">{props.error.last_name}</Alert>
                    ):null}
                  </Col>
                  <Col  sm='12' md='6'>
                    <Label
                      for="documentType"
                      className={styles["label"]}
                    >
                      Tipo de Documento
                    </Label>
                    <select
                      className= {styles["input"]}
                      id="documentType"
                      name="documentType"
                      type="text"
                      onChange={onChange}                      
                      required 
                    >
                      <option defaultValue>Seleccione una opcion</option>
                      <option value ="CEDULA">CEDULA</option>
                      <option value ="PASAPORTE">PASAPORTE</option>
                      <option value ="CEDULA_EXTRANJERIA">CEDULA EXTRAJERIA</option>
                      <option value ="NIT">NIT</option>
                      <option value ="OTRO">OTRO</option>
                    </select>
                    {props.error && props.error.documentType ? (
                    <Alert color = 'danger' className="mt-2">{props.error.documentType}</Alert>
                    ):null}
                  </Col>
                </Row>
                <Row>
                <Col  sm='12' md='6'> 
                    <Label
                      for="documentNumber"
                      className={styles["label"]}
                    >
                      Documento
                    </Label>
                    <input
                      className= {styles["input"]}
                      id="documentNumber"
                      name="documentNumber"
                      type="number"
                      onChange={onChange}
                      value={documentNumber}
                      required 
                    />
                    {props.error && props.error.documentNumber ? (
                    <Alert color = 'danger' className="mt-2">{props.error.documentNumber}</Alert>
                    ):null}
                  </Col>
                  <Col  sm='12' md='6'>
                    <Label
                      for="password"
                      className={styles["label"]}
                    >
                      Contraseña
                    </Label>
                    <input
                      className= {styles["input"]}
                      id="password"
                      name="password"
                      type={showPassword ? "text" : "password"}
                      onChange={onChange}
                      value={password}
                      required 
                    />
                    {props.error && props.error.password ? (
                    <Alert color = 'danger' className="mt-2">{props.error.password}</Alert>
                    ):null}
                    <label className={styles["password-toggle-label"]}>
                    Mostrar contraseña
                    <input
                      type="checkbox"
                      checked={showPassword}
                      onChange={togglePasswordVisibility}
                    />
                  </label>
                  </Col>
                
                </Row>

                  <Col sm={6}>
                    <Label
                      for="confirm_password"
                      className={styles["label"]}
                    >
                      Confirmación de Contraseña
                    </Label>
                    <input
                     className= {styles["input"]}
                      id="confirm_password"
                      name="confirm_password"
                      type={showConfirm ? "text" : "password"}
                      onChange={onChange}
                      value={confirm_password}
                      required 
                    />
                    {props.error && props.error.confirm_password ? (
                    <Alert color = 'danger' className="mt-2">
                      {props.error.confirm_password}
                    </Alert>
                    ):null}

                    <label className={styles["password-toggle-label"]}>
                    Mostrar confirmacion
                    <input
                      type="checkbox"
                      checked={showConfirm}
                      onChange={toggleConfirmVisibility}
                    />
                  </label>
                  </Col>
     
                    
              
              <Row className="mt-2 col-lg-12 justify-content-center" >

                <Col md={3} >
                <button className={`mx-2 ${styles["submit"]}`} onClick={()=> history.push("/login")}>

                    Volver
                  </button>
                </Col>
                <Col md={3}>
                <button className={`mx-2 ${styles["submit"]}`} onClick={()=> history.push("/login")}>

                    Enviar
                  </button>
                </Col>
              </Row>
            </Form>
            </Row>
          </Col>

        </Row>
            

      </Container>

  </React.Fragment>

  );
};

const mapStateToProps = (state) => {
  const { error, loading, contactsCreated } = state.Contacts;
  return { error, loading, contactsCreated };
};

UserAddPublic.propTypes = {
  error: PropTypes.any,
  loading: PropTypes.bool,
  contactsCreateded: PropTypes.object,
};
export default withRouter(connect(mapStateToProps, { contactsCreateLogin })(UserAddPublic));




